import { authenticatedAjax, REQUEST } from "../../../../config/ajax-wrapper";
import { AnyAction } from "redux";
import fileDownload from "js-file-download";
import {
    ENVIAR_SAT_AFILIADO,
    ENVIAR_SAT_MASIVO_AFILIADOS,
    ERROR_AUTORIZACION,
    ERROR_ENVIO_AFILIACION_INDIVIDUAL,
    ERROR_ENVIO_AFILIACION_MASIVO,
    ENVIO_EXITOSO_AFILIACION,
    ENVIO_EXITOSO_AFILIACION_MASIVO,
    DESCARGAR_PLANTILLA_MASIVO_AFILIACION,
    PLANTILLA_AFILIACION_OBTENIDA,
    ERROR_OBTENIENDO_PLANTILLA_AFILIACION,
    errorAutorizacion,
    errorEnvioAfiliacionIndividual,
    errorEnvioAfiliacionMasivo,
    envioAfiliacionExito,
    envioAfiliacionMasivoExito,
    plantillaAfiliacionObtenida,
    errorObteniendoPlantillaAfiliacion,
    LIMPIAR_MENSAJES_AFILIACION
} from "../modulos/procesarEmpresaActions";

export const enviarSATAfiliadoEpic = action$ =>
    action$.ofType(ENVIAR_SAT_AFILIADO)
        .mergeMap((action: any) => {

            const url = `sat/afiliacion/envio-individual`;

            return authenticatedAjax
                .post(
                    url,
                    action.datosEnvioAfiliacion,
                    { 'Content-Type': 'application/json', 'proceso': 'AFILIACION' }
                )
                .map(response => {
                    const respuesta = response.response.datos;
                    return envioAfiliacionExito(respuesta.poliza, respuesta.dni);
                }).catch(response => {
                    if (response.status === 401 || response.status === 403) {
                        return [errorAutorizacion()];
                    } else {
                        const respuesta = response.response;
                        const mensajeRespuesta = (response.response && respuesta.mensajeRespuesta) ? respuesta.mensajeRespuesta : "Error no controlado en la aplicación";
                        return [errorEnvioAfiliacionIndividual(mensajeRespuesta)];
                    }
                });
        });

export const enviarSATMasivoAfiliadosEpic = action$ =>
    action$.ofType(ENVIAR_SAT_MASIVO_AFILIADOS)
        .mergeMap((action: any) => {

            const url = `sat/afiliacion/envio-masivo`;

            return authenticatedAjax
                .upload(
                    url,
                    action.archivoEnvio, {}, { 'proceso': 'AFILIACION' }
                )
                .map((response) => {
                    return envioAfiliacionMasivoExito();
                }).catch(response => {
                    if (response.status === 401 || response.status === 403) {
                        return [errorAutorizacion()];
                    } else {
                        const respuesta = response.response;
                        const mensajeRespuesta = (response.response && respuesta.mensajeRespuesta) ? respuesta.mensajeRespuesta : "Error no controlado en la aplicación";
                        return [errorEnvioAfiliacionMasivo(mensajeRespuesta)];
                    }
                });
        });

export const descargarPlantillaMasivoEpic = action$ =>
    action$.ofType(DESCARGAR_PLANTILLA_MASIVO_AFILIACION)
        .mergeMap((action: any) => {

            const url = `sat/descargas/plantilla-afiliacion`;

            return authenticatedAjax
                .getBlob(url)
                .map((response) => {
                    const data = response.response;
                    fileDownload(
                        data,
                        "plantilla_masivo_afiliacion.xlsx",
                        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                    );
                    return plantillaAfiliacionObtenida();
                }).catch(response =>
                    [errorObteniendoPlantillaAfiliacion()]
                );
        });

export const envioEmpresasReducer = (state =
    {
        estadoEnvio: REQUEST.NONE,
        mensajeUsuario: undefined,
        poliza: undefined,
        dni: undefined
    }, action: AnyAction) => {

    switch (action.type) {

        case ENVIAR_SAT_AFILIADO:
            return {
                ...state,
                estadoEnvioIndividual: REQUEST.PENDING,
                estadoEnvioMasivo: REQUEST.NONE
            };
        case ENVIAR_SAT_MASIVO_AFILIADOS:
            return {
                ...state,
                estadoEnvioIndividual: REQUEST.NONE,
                estadoEnvioMasivo: REQUEST.PENDING
            };
        case ENVIO_EXITOSO_AFILIACION:
            return {
                ...state,
                estadoEnvioIndividual: REQUEST.SUCCESS,
                estadoEnvioMasivo: REQUEST.NONE,
                poliza: action.poliza,
                dni: action.dni
            };
        case ENVIO_EXITOSO_AFILIACION_MASIVO:
            return {
                ...state,
                estadoEnvioMasivo: REQUEST.SUCCESS,
                estadoEnvioIndividual: REQUEST.NONE
            };
        case ERROR_AUTORIZACION:
            return {
                ...state,
                estadoEnvioIndividual: REQUEST.FORBIDDEN,
                estadoEnvioMasivo: REQUEST.FORBIDDEN
            };
        case ERROR_ENVIO_AFILIACION_INDIVIDUAL:
            return {
                ...state,
                estadoEnvioIndividual: REQUEST.ERROR,
                mensajeUsuario: action.mensajeRespuesta
            };
        case ERROR_ENVIO_AFILIACION_MASIVO:
            return {
                ...state,
                estadoEnvioMasivo: REQUEST.ERROR,
                mensajeUsuario: action.mensajeRespuesta
            };
        case LIMPIAR_MENSAJES_AFILIACION:
            return {
                estadoEnvioIndividual: REQUEST.NONE,
                estadoEnvioMasivo: REQUEST.NONE,
                poliza: undefined,
                dni: undefined,
                mensajeUsuario: undefined
            };
        case PLANTILLA_AFILIACION_OBTENIDA:
        case ERROR_OBTENIENDO_PLANTILLA_AFILIACION:
            return { ...state };
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/procesar_empresas/modulos/procesarEmpresasReducers.ts